import React from "react";
import { Flex } from "antd";
import RedesignButton from "~/shared/ui/Fields/RedesignButton";
import Modal from "~/shared/ui/Fields/Modal";
import { AppealStateFormIProps } from "~/pages/Appeal/ui/Appeal";
import { IAppealSendForm } from "../model/schema";
import { IAppealSchema } from "~/entity/Appeals/model/schema";

interface AppealConfimrationIProps {
  openModal: boolean;
  close: () => void;
  dataConfirmation: AppealStateFormIProps;
  onSubmit: (data: IAppealSendForm, value: IAppealSchema) => void;
}

const AppealConfimration = ({
  openModal,
  close,
  dataConfirmation,
  onSubmit,
}: AppealConfimrationIProps) => {
  return (
    <Modal isOpen={openModal} actionClose={close} title="Подтверждение">
      <Flex gap={24} vertical align={"start"} style={{ width: "100%" }}>
        <div>
          <span>Вы уверены в отправке решения? </span>
        </div>
        <Flex gap={10}>
          <RedesignButton theme={"main"} onClick={close} txtBtn={"Назад"} />
          <RedesignButton
            theme={"accent"}
            txtBtn={"Подтвердить и отправить"}
            onClick={() => {
              onSubmit(dataConfirmation.value, dataConfirmation.appeal);
              close();
            }}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};
export default AppealConfimration;
